function interactionListener(elements, action, callback, type = 'add') {
  if (type !== 'add' && type !== 'remove') {
    throw `"${type}" is an invalid type`;
  }

  if (elements) {
    if (Array.isArray(elements)) {
      elements.forEach((element) => {
        element[`${type}EventListener`](action, callback);
      });
    } else {
      elements[`${type}EventListener`](action, callback);
    }
  }
}

export { interactionListener };
